import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Section Components
import HeroSection from './components/sections/HeroSection';
import AgentTypesSection from './components/sections/AgentTypesSection';
import FeaturesSection from './components/sections/FeaturesSection';
import UseCasesSection from './components/sections/UseCasesSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import IntegrationsSection from './components/sections/IntegrationsSection';
import SecuritySection from './components/sections/SecuritySection';
import PricingSection from './components/sections/PricingSection';
import CTASection from './components/sections/CTASection';
import BookDemoModal from './components/BookDemoModal';
import GetStartedModal from './components/GetStartedModal';

// API URL - uses relative path for same-domain hosting (Hostinger)
// Falls back to env variable for development
const API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api` 
  : '/api';

const LandingPage = () => {
  const [isBookDemoOpen, setIsBookDemoOpen] = useState(false);
  const [isGetStartedOpen, setIsGetStartedOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');

  const handleOpenBookDemo = () => setIsBookDemoOpen(true);
  const handleCloseBookDemo = () => setIsBookDemoOpen(false);

  const handleOpenGetStarted = (plan = '') => {
    setSelectedPlan(plan);
    setIsGetStartedOpen(true);
  };
  const handleCloseGetStarted = () => {
    setSelectedPlan('');
    setIsGetStartedOpen(false);
  };

  const handleSubmitDemo = async (formData) => {
    setIsLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...formData, leadType: 'demo_request' });
      console.log('Demo request submitted successfully:', formData);
    } catch (error) {
      console.error('Error submitting demo request:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitGetStarted = async (formData) => {
    setIsLoading(true);
    try {
      await axios.post(`${API}/leads`, formData);
      console.log('Get Started request submitted successfully:', formData);
    } catch (error) {
      console.error('Error submitting get started request:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Semantic Header with Navigation */}
      <header role="banner">
        <Navbar onBookDemo={handleOpenBookDemo} onGetStarted={() => handleOpenGetStarted()} />
      </header>
      
      {/* Main Content Area */}
      <main role="main" id="main-content">
        <article>
          <HeroSection onBookDemo={handleOpenBookDemo} onGetStarted={() => handleOpenGetStarted()} />
        </article>
        
        <section aria-labelledby="solutions-heading">
          <AgentTypesSection />
        </section>
        
        <section aria-labelledby="features-heading">
          <FeaturesSection />
        </section>
        
        <section aria-labelledby="usecases-heading">
          <UseCasesSection onBookDemo={handleOpenBookDemo} />
        </section>
        
        <section aria-labelledby="testimonials-heading">
          <TestimonialsSection onBookDemo={handleOpenBookDemo} />
        </section>
        
        <section aria-labelledby="integrations-heading">
          <IntegrationsSection />
        </section>
        
        <section aria-labelledby="pricing-heading">
          <PricingSection onGetStarted={handleOpenGetStarted} />
        </section>
        
        <section aria-labelledby="security-heading">
          <SecuritySection onBookDemo={handleOpenBookDemo} />
        </section>
        
        <aside aria-label="Call to action">
          <CTASection onBookDemo={handleOpenBookDemo} onGetStarted={() => handleOpenGetStarted()} />
        </aside>
      </main>
      
      {/* Semantic Footer */}
      <Footer />
      
      {/* Modals */}
      <BookDemoModal
        isOpen={isBookDemoOpen}
        onClose={handleCloseBookDemo}
        onSubmit={handleSubmitDemo}
        isLoading={isLoading}
      />
      <GetStartedModal
        isOpen={isGetStartedOpen}
        onClose={handleCloseGetStarted}
        onSubmit={handleSubmitGetStarted}
        isLoading={isLoading}
        selectedPlan={selectedPlan}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
